import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import SwipeableViews from 'react-swipeable-views';
import { useTheme } from "@mui/material/styles";
import PieChartIcon from "@mui/icons-material/PieChart";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Tabs,
  Tab,
  Button,
  Container,
  CircularProgress,
  Paper,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Schedule from "../../../views/myDesign/zones/Schedule";
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna";
import CreateIcon from "@mui/icons-material/Create";
import { useSnackbar } from "notistack";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import ZoneContentManager from "../../../components/ZoneContentManager/zoneContentManager";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import TocIcon from "@mui/icons-material/Toc";
import clsx from "clsx";
import ConfirmationDialog from "../../../components/dialog/ConfirmationDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { TextField, Autocomplete } from "@mui/material";
import {
  deleteZone,
  fetchPlaylist,
  fetchSelectedZoneContent,
  fetchSingleMyDesign,
  fetchZones,
  updateZoneLabel,
  sendNotification,
} from "../../../reducers/myDesigns/myDesignsThunks";
import {
  openBackdrop,
  playlistChangedUpdate,
} from "../../../reducers/myDesigns/myDesignsSlice";
import { myDesignService } from "../../../services";
import { PlayCircleOutline, UploadFile } from "@mui/icons-material";

const PREFIX = "ZoneManager";

const classes = {
  mainContainer: `${PREFIX}-mainContainer`,
  autocomplete: `${PREFIX}-autocomplete`,
  actionButton: `${PREFIX}-actionButton`,
  displayIcons: `${PREFIX}-displayIcons`,
  ADSIconButton: `${PREFIX}-ADSIconButton`,
  goBackButtonMargin: `${PREFIX}-goBackButtonMargin`,
  marginIcon: `${PREFIX}-marginIcon`,
  targetUrlContainer: `${PREFIX}-targetUrlContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  editImageIcon: `${PREFIX}-editImageIcon`,
  changeLabelZone: `${PREFIX}-changeLabelZone`,
  contentPaperRoot: `${PREFIX}-contentPaperRoot`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.mainContainer}`]: {
    textAlign: "center",
    padding: "1rem 0",
    width: "60%",
    minHeight: "100px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.between("xs", "md")]: {
      flexDirection: "column",
      width: "100%",
    },
  },

  [`& .${classes.autocomplete}`]: {
    width: "100%",
    maxWidth: "350px",
    margin: "1rem 0",
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
  },

  [`& .${classes.actionButton}`]: {
    margin: "0.5rem 0 0.5rem 0",
    backgroundColor: theme.palette.primary.main,
  },

  [`& .${classes.displayIcons}`]: {
    display: "flex",
    justifyContent: "space-around",
  },

  [`& .${classes.ADSIconButton}`]: {
    width: "45px !important",
    height: "43px !important",
    color: "rgba(255,255,255,1)",
  },

  [`& .${classes.goBackButtonMargin}`]: {
    margin: "1rem 0.5rem",
  },

  [`& .${classes.marginIcon}`]: {
    marginRight: "0.5rem",
  },

  [`& .${classes.targetUrlContainer}`]: {
    maxWidth: "350px",
    position: "relative",
    left: "50%",
    transform: "translate(-50%)",
    [theme.breakpoints.between("xs", "md")]: {
      marginBottom: "0",
      marginLeft: "0",
    },
  },

  [`& .${classes.buttonContainer}`]: {
    width: "350px",
    maxWidth: "100%",
  },

  [`& .${classes.editImageIcon}`]: {
    position: "absolute",
    right: "2.5rem",
    top: "0",
  },

  [`& .${classes.changeLabelZone}`]: {
    marginTop: "1rem",
  },

  [`& .${classes.contentPaperRoot}`]: {
    backgroundColor: "#424242",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={props.disablegutters ? 0 : 3}>{children}</Box>
      )}
    </div>
  );
}

function ZoneManager() {
  const location = useLocation();
  const theme = useTheme();
  const { t } = useTranslation();
  const { id, idZone } = useParams();
  const dispatch = useDispatch();
  const history = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState("");
  const currentDesign = useSelector((state) => state.myDesigns.currentDesign);
  const playlistChanged = useSelector(
    (state) => state.myDesigns.playlistChanged
  );
  const loading = useSelector((state) => state.myDesigns.selectedZone.loading);
  const [selectedTarget, setSelectedTarget] = useState(null);
  const isAdmin = useSelector(
    (state) => state.user?.currentUser?.account?.role
  );
  const [url, setUrl] = useState(null);
  const [index, setIndex] = useState(
    location.state && location.state.index ? location.state.index : 0
  );
  const [currentZone, setCurrentZone] = useState(null);
  const [filteredZones, setFilteredZones] = useState(null);
  const [openConfirmation, setOpenConfirmation] = React.useState(false);
  const [newName, setNewName] = useState("");
  const backdropStatus = useSelector(
    (state) => state.myDesigns?.backdropRequest
  );

  const fetchMyPlaylist = async (zoneId, token = null) => {
    try {
      const thunk = await dispatch(
        fetchPlaylist({
          zoneId,
          token,
        })
      );
      if (thunk.meta.requestStatus === "rejected") throw new Error("offline");
    } catch {
      enqueueSnackbar(t("toasts.getInfosError"), { variant: "error" });
    }
  };

  const fetchMySelectedZoneContent = async (zoneId) => {
    try {
      const thunk = await dispatch(fetchSelectedZoneContent(zoneId));
      if (thunk.meta.requestStatus === "rejected") throw new Error("offline");
    } catch {
      enqueueSnackbar(t("toasts.getInfosError"), { variant: "error" });
    }
  };

  useEffect(() => {
    if (
      backdropStatus &&
      backdropStatus.from === "" &&
      !backdropStatus.status &&
      currentZone &&
      currentZone.id
    ) {
      fetchMySelectedZoneContent(currentZone.id);
      fetchMyPlaylist(currentZone.id);
    }
  }, [backdropStatus]);

  const [playlistTab, setPlaylistTab] = React.useState(0);

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }

  function handleChange(e, value) {
    setIndex(value);
  }

  function handleChangeIndex(index, indexLatest, meta) {
    setIndex(index);
  }

  useEffect(() => {
    if (playlistChanged) {
      dispatch(playlistChangedUpdate());
    }
  }, [playlistChanged]);

  //changement de myDesign ou via recherche
  useEffect(() => {
    if (
      currentDesign &&
      currentDesign.targets &&
      currentDesign.targets.length > 0 &&
      currentDesign.zones &&
      currentDesign.zones.length > 0 &&
      currentDesign.targets[0].frameId === currentDesign.zones[0].frameId &&
      !playlistChanged
    ) {
      const tmpZone = currentDesign.zones.find(
        (zone) => Number(idZone) === zone.id
      );
      if (tmpZone) {
        const tmp = currentDesign.targets.find(
          (target) => target.label === tmpZone.target
        );
        setSelectedTarget(tmp);
        setTitle(tmp.label);
      } else {
        history(`/mydesign/${id}`);
      }
    }
    if (
      currentDesign &&
      currentDesign.zones &&
      currentDesign.zones.length > 0 &&
      currentDesign &&
      currentDesign.targets &&
      currentDesign.targets.length > 0 &&
      currentDesign.targets[0].frameId === currentDesign.zones[0].frameId &&
      !playlistChanged
    ) {
      const tmp = currentDesign.zones.filter(
        (zone) => zone.id === Number(idZone)
      );
      if (tmp.length > 0) {
        setCurrentZone(tmp[0]);
        const filteredZones = currentDesign.zones.filter(
          (zone) => zone.target === tmp[0].target
        );
        setFilteredZones(filteredZones);
      }
    }
  }, [currentDesign]);

  // update si meme target mais changement de zone via la recherche
  useEffect(() => {
    if (currentDesign && currentDesign.zones) {
      const tmp = currentDesign.zones.filter(
        (zone) => zone.id === Number(idZone)
      );
      setCurrentZone(tmp[0]);
    }
  }, [idZone]);

  const fetchMySingleMyDesigns = async (id) => {
    try {
      const thunk = await dispatch(fetchSingleMyDesign(id));
      if (thunk.meta.requestStatus === "rejected") throw new Error("offline");
    } catch {
      enqueueSnackbar(t("toasts.unknownError"), { variant: "error" });
    }
  };

  const fetchMyZones = async (id) => {
    try {
      const thunk = await dispatch(fetchZones(id));
      if (thunk.meta.requestStatus === "rejected") throw new Error("offline");
    } catch {
      enqueueSnackbar(t("toasts.unknownError"), { variant: "error" });
    }
  };

  //onMount
  useEffect(() => {
    if (id) {
      fetchMyZones(id);
      fetchMySingleMyDesigns(id);
    }
  }, [id]);

  //changement de zone via l'autocomplete (current.id listened to avoid double fetch onMount)
  useEffect(() => {
    if (currentZone) {
      setNewName(currentZone.label);
      setUrl(
        currentZone.imageUrl ? currentZone.imageUrl : currentDesign.imageUrl
      );
      fetchMySelectedZoneContent(currentZone.id);
      fetchMyPlaylist(currentZone.id);
    }
  }, [currentZone && currentZone.id]);

  const handleChangeName = (v) => {
    setNewName(v);
  };

  const updateMyZoneLabel = async (
    targetUrl,
    frameId,
    target,
    zoneId,
    label,
    tmp,
    tmpFiltered
  ) => {
    try {
      const thunk = await dispatch(
        updateZoneLabel({ targetUrl, frameId, target, zoneId, label })
      );
      if (thunk.meta.requestStatus === "rejected") throw new Error("offline");
      setCurrentZone(tmp);
      setFilteredZones(tmpFiltered);
      enqueueSnackbar(t("toasts.updateZoneLabelSuccess"), {
        variant: "success",
      });
    } catch {
      enqueueSnackbar(t("toasts.updateZoneLabelError"), { variant: "error" });
    }
  };

  const mySendNotification = async () => {
    try {
      const thunk = await dispatch(
        sendNotification({
          frameId: currentZone.frameId,
          frameName: title,
          label: selectedTarget.label,
          zoneName: currentZone.label,
        })
      );
      if (thunk.meta.requestStatus === "rejected")
        throw new Error("recovery error");
      enqueueSnackbar(t("toasts.notificationSent"), { variant: "success" });
    } catch (err) {
      enqueueSnackbar(t("toasts.unknownError"), { variant: "error" });
    }
  };

  const handleSaveName = () => {
    let tmp = { ...currentZone };
    tmp.label = newName;
    let tmpFiltered = [...filteredZones];
    tmpFiltered[filteredZones.findIndex((zone) => zone.id === tmp.id)] = {
      ...tmpFiltered[filteredZones.findIndex((zone) => zone.id === tmp.id)],
      label: newName,
    };
    updateMyZoneLabel(
      currentZone.targetUrl,
      currentZone.frameId,
      currentZone.target,
      currentZone.index,
      newName,
      tmp,
      tmpFiltered
    );
  };

  const deleteMyZone = async (frameId, zone, target) => {
    try {
      const thunk = await dispatch(deleteZone({ frameId, zone, target }));
      if (thunk.meta.requestStatus === "rejected") throw new Error("offline");
      enqueueSnackbar(t("toasts.deleteZoneSuccess"), { variant: "success" });
      history(`/mydesign/${currentZone.frameId}`);
    } catch {
      enqueueSnackbar(t("toasts.deleteZoneError"), { variant: "error" });
    }
  };

  const uploadButtonFunction = () => {
    dispatch(
      openBackdrop({
        from: "modify",
        infos: { ...currentZone, title },
      })
    );
  };

  if (!currentZone || !selectedTarget || !currentDesign) {
    return (
      <Container>
        <div className="loading-container">
          <CircularProgress size={50} />
        </div>
      </Container>
    );
  } else {
    return (
      <Root>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.goBackButtonMargin}
          onClick={() =>
            history(`/mydesign/${currentZone.frameId}`, {
              state: {
                index: isAdmin === "ADMIN" ? 2 : 1,
                targetLabel: currentZone.target,
              },
            })
          }
        >
          <KeyboardReturnIcon className={classes.marginIcon} />
          {title}
        </Button>
        <div>
          <Container style={{ textAlign: "center" }}>
            <Autocomplete
              label="zones"
              id="autocomplete-zones"
              disableClearable
              className={classes.autocomplete}
              options={filteredZones.map((zone) => zone)}
              getOptionLabel={(option) =>
                currentZone.target + " - " + option.label
              }
              renderInput={(params) => (
                <TextField {...params} label="Zones" variant="outlined" />
              )}
              value={currentZone}
              onChange={(e, value) => setCurrentZone(value)}
            />
          </Container>
          <Tabs
            value={index}
            variant="fullWidth"
            onChange={handleChange}
            indicatorColor="primary"
            aria-label="full width tabs my design"
          >
            <Tab
              icon={<PieChartIcon />}
              aria-label="informations"
              {...a11yProps(0)}
            />
            <Tab
              icon={<PlaylistPlayIcon />}
              aria-label="playlist"
              {...a11yProps(1)}
            />
            <Tab icon={<EventIcon />} aria-label="targets" {...a11yProps(2)} />
          </Tabs>
        </div>
        <TabPanel value={index} index={0} dir={theme.direction}>
          <Container className={classes.mainContainer}>
            <Container
              disableGutters
              style={{ maxWidth: "400px", position: "relative" }}
            >
              {loading ? (
                <CircularProgress size={50} />
              ) : (
                <img
                  src={url}
                  onError={(e) => {
                    setUrl(currentDesign.imageUrl);
                  }}
                  alt="painting"
                  style={{
                    width: "100%",
                    maxWidth: "300px",
                    borderRadius: "10px",
                  }}
                />
              )}
              {isAdmin === "ADMIN" && (
                <div className={classes.editImageIcon}>
                  <input
                    type="file"
                    accept="image/*"
                    name="myDesignImage"
                    id="icon-button-file"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      myDesignService
                        .updateImageZone(
                          id,
                          selectedTarget.label,
                          currentZone.index,
                          e.target.files
                        )
                        .then(() => {
                          enqueueSnackbar(t("toasts.updateZoneImageSuccess"), {
                            variant: "success",
                          });
                          setUrl(URL.createObjectURL(e.target.files[0]));
                        })
                        .catch((err) => {
                          if (err === 403)
                            enqueueSnackbar(t("toasts.unauthorizedError"), {
                              variant: "error",
                            });
                          else
                            enqueueSnackbar(t("toasts.updateZoneImageError"), {
                              variant: "error",
                            });
                        });
                    }}
                  />
                  <label htmlFor="icon-button-file">
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      size="large"
                    >
                      <CreateIcon />
                    </IconButton>
                  </label>
                </div>
              )}
              {isAdmin === "ADMIN" && (
                <Box className={classes.changeLabelZone}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="Label"
                    label={t("myDesign.zones.zoneLabel")}
                    onChange={(e) => handleChangeName(e.target.value)}
                    autoComplete="Label"
                    value={newName}
                    className={classes.targetUrl}
                    style={{ marginBottom: "0.5rem", marginTop: "0" }}
                  />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => handleSaveName()}
                    size="large"
                  >
                    <SaveIcon />
                  </IconButton>
                </Box>
              )}
            </Container>
            <Box className={classes.targetUrlContainer}>
              {isAdmin === "ADMIN" && (
                <ConfirmationDialog
                  open={openConfirmation}
                  setOpen={setOpenConfirmation}
                  element={currentZone}
                  onAgree={() => {
                    deleteMyZone(
                      currentZone.frameId,
                      currentZone.index,
                      selectedTarget.label
                    );
                  }}
                  mode="deleteZone"
                />
              )}
              <div
                className={clsx(classes.buttonContainer, classes.displayIcons)}
              >
                {(currentZone.previewAccess === 1 || isAdmin === "ADMIN") && (
                  <IconButton
                    color="inherit"
                    aria-label="preview"
                    edge="end"
                    onClick={() =>
                      window.open(
                        `${process.env.REACT_APP_API_URL}/r/${currentZone.uniqueKey}/test`,
                        "_blank"
                      )
                    }
                    className={classes.actionButton}
                    size="large"
                  >
                    <PlayCircleOutline className={classes.ADSIconButton} />
                  </IconButton>
                )}
                {(currentZone.notifyAccess === 1 || isAdmin === "ADMIN") && (
                  <IconButton
                    color="inherit"
                    aria-label="notify"
                    edge="end"
                    onClick={() => {
                      mySendNotification();
                    }}
                    className={classes.actionButton}
                    size="large"
                  >
                    <SettingsInputAntennaIcon
                      className={classes.ADSIconButton}
                    />
                  </IconButton>
                )}
                {(currentZone.saveAccess === 1 ||
                  currentZone.uploadAccess === 1 ||
                  isAdmin === "ADMIN") && (
                  <IconButton
                    color="inherit"
                    aria-label="modify"
                    edge="end"
                    onClick={uploadButtonFunction}
                    className={classes.actionButton}
                    size="large"
                  >
                    <UploadFile className={classes.ADSIconButton} />
                  </IconButton>
                )}
                {isAdmin === "ADMIN" && (
                  <IconButton
                    color="inherit"
                    aria-label="open in mobile application"
                    edge="end"
                    onClick={() => setOpenConfirmation(true)}
                    className={classes.actionButton}
                    size="large"
                  >
                    <DeleteIcon className={classes.ADSIconButton} />
                  </IconButton>
                )}
              </div>
            </Box>
          </Container>
        </TabPanel>
        <TabPanel value={index} index={1} dir={theme.direction}>
          <Paper className={classes.contentPaperRoot}>
            <Tabs
              value={playlistTab}
              onChange={(e, value) => setPlaylistTab(value)}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab
                label={t("myDesign.zones.playlists.subTabPlaylist")}
                {...a11yProps(0)}
              />
              <Tab
                label={t("myDesign.zones.playlists.subTabUnusedContent")}
                {...a11yProps(1)}
              />
            </Tabs>
          </Paper>
          <TabPanel value={playlistTab} index={0} disablegutters="true">
            <ZoneContentManager
              currentZone={currentZone}
              setCurrentZone={setCurrentZone}
              orderPlaylist
              sendNotification={mySendNotification}
              upload={uploadButtonFunction}
            />
          </TabPanel>
          <TabPanel value={playlistTab} index={1} disablegutters="true">
            <ZoneContentManager currentZone={currentZone} />
          </TabPanel>
        </TabPanel>
        <TabPanel value={index} index={2} dir={theme.direction}>
          <Schedule
            target={currentZone.target}
            index={currentZone.index}
            frameId={currentZone.frameId}
            currentZone={currentZone}
            zones={currentDesign.zones}
            timezone={selectedTarget.timezone}
            isAdmin={isAdmin === "ADMIN"}
          />
        </TabPanel>
      </Root>
    );
  }
}

export default ZoneManager;
